export default __webpack_public_path__ + "static/media/nextIcon.b5853511.svg";